import { combineReducers } from '@reduxjs/toolkit';
import sidebar from './sidebarSlice'
const reducer = combineReducers({
  sidebar,
});

export default reducer;
